webModule.controller('MainAppController', ['$scope', '$location', '$window', 'userAuthenticateService', 'authorizationService', 'routes',
        '$interval', 'dealershipService', 'imSessionVarsService', 'AppSettings','quoteIntegrationConstants','erateSessionVarsService', 'themeService',
        'RemitAccessTypes','providerFeaturesService', 'usageEventsService',
    function ($scope, $location, $window, userAuthenticateService, authorizationService, routes,
              $interval, dealershipService, imSessionVarsService, AppSettings, quoteIntegrationConstants,erateSessionVarsService, themeService,
              RemitAccessTypes, providerFeaturesService, usageEventsService) {
        // select all routes that are not login
        $scope.securedLocations = Object.keys(routes).filter(securedAuthorizedRouteFilter).map(function(key) {
            return routes[key];
        });

        $scope.quoteModeMaster = null;
        $scope.menuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
        $scope.menuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;

        $scope.location = $location;
        $scope.routes = routes;
        $scope.authenticated = false;
        $scope.dealership = dealershipService.dealershipInfo;
        $scope.growlEnabled = AppSettings.growlEnabled;
        $scope.currentTheme = themeService.getCurrentTheme;

        $scope.$watch(function () { return erateSessionVarsService.getQuotingMode(); }, function (newValue, oldValue) {
            $scope.quoteModeMaster = newValue;
        });

        $scope.showRemittanceLink = false;
        $scope.$watch(function () { return imSessionVarsService.getCurrentProviderId(); }, function (newValue, oldValue) {
                providerFeaturesService.getProviderApplicationSetting(RemitAccessTypes.AllowRemitContract,'false')
                .then(
                    function(element){
                        $scope.showRemittanceLink = element.toString().toUpperCase() === "TRUE";
                    }
                );
        });

        $scope.$watch(function () { return $location.path(); }, function (newValue, oldValue) {
            if (newValue.substr(newValue.length -1,1) == '/'){
                newValue = newValue.substr(0, newValue.length - 1);
            }
            if ($scope.securedLocations.indexOf(newValue) >= 0 && !$scope.authenticated) {
                userAuthenticateService.IsUserAuthenticated()
                        .success(function (response) {
                            $scope.authenticated = true;
                        })
                        .error(function (response, status, headers, config) {
                            alert('You must log in before continuing.');
                            $location.path(routes.login);
                        });
            }
            //creating an array for authorizedlocations when we login, refresh or we are redirected either sso-redirect or coming from Menu integrated
            if (oldValue == '/login' || oldValue == newValue || oldValue == '/sso-redirect/' || oldValue == '/sso-redirect' || oldValue == '/quote-integration'){
                $scope.authorizedLocations = Object.keys(routes).filter(securedAuthorizedRouteFilter).map(function(key) {
                    return authorizationService.isUrlAccessibleForUser(routes[key])
                });
            }
            AppSettings.showErrorsOnConsole = AppSettings.showErrorsOnConsole || $location.url().toUpperCase().indexOf('CONSOLEERR=Y') >= 0;

        });

        $scope.showSideNav = false;

        $scope.toggleSideNav = function () {
            $scope.showSideNav = ! $scope.showSideNav;
            dealershipService.refreshDealerName();
            $scope.dealership = dealershipService.dealershipInfo;
        };

        function evaluateUrlPath(urlPath) {
            try { urlPath = $scope.$eval(urlPath); }
            catch(e) { /*Empty*/ }
            return urlPath;
        }

        $scope.navigate = function(urlPath) {
            $scope.showSideNav = false;
            $location.path(evaluateUrlPath(urlPath));
        };

        $scope.logout = function() {
            if (erateSessionVarsService.getProviderLogoutUrl()) {
                $window.location = erateSessionVarsService.getProviderLogoutUrl(); // redirect back to provider portal
                return;
            }
            $scope.showSideNav = false;
            $location.path(routes.logout);
        };

        $scope.isAuthorized = function(urlPath) {
            var result = false;
            if (!$scope.authorizedLocations) {
                return result;
            }
            var index = $scope.securedLocations.indexOf(evaluateUrlPath(urlPath));
            if (index > -1 && index < $scope.authorizedLocations.length) {
                result = $scope.authorizedLocations[index];
            }
            return result;
        }

        $scope.renewUserToken = function(){
            var tk = userAuthenticateService.getUserToken();

            if (tk){
                userAuthenticateService.GetRenewedToken()
                    .then(
                    function(tok){
                        userAuthenticateService.setUserToken(tok);
                    },
                    function(err){
                        throw err;
                    }
                )
            }
        }

        function securedAuthorizedRouteFilter(key) {
            return routes[key] !== routes.login
                && routes[key] !== routes.ssoIntegration
                && routes[key] !== routes.error
                && routes[key] !== routes.showcaseLiteRedirect
                && routes[key] !== routes.quoteIntegration;
        };

        (function endlessRenewToken(){
            $scope.renewUserToken();
            $interval(function () {
                $scope.renewUserToken();
            }, 1000 * 7 * 60);
            //every seven minutes, refresh the user's token
        })();
    }
]);
